import React from 'react';
import {
  DataGridPremium,
  DataGridPremiumProps,
} from '@mui/x-data-grid-premium';
import { useDataGridEnhancer } from './useDataGridEnhancer';
import { DATAGRID_STYLES, DATAGRID_DEFAULT_PROPS } from './DataGridUtils';
import './DataGridStyles.scss';

// Styled DataGrid component with consistent styling
interface StyledDataGridProps extends Omit<DataGridPremiumProps, 'sx'> {
  sx?: object;
  enableClipboard?: boolean;
  enableExport?: boolean;
  onClipboardCopy?: (value: string) => void;
  onClipboardPaste?: (value: string) => void;
  'data-testid'?: string;
  treeData?: boolean;
}

export const StyledDataGrid: React.FC<StyledDataGridProps> = ({
  sx = {},
  enableClipboard = true,
  enableExport = true,
  onClipboardCopy,
  onClipboardPaste,
  treeData = false,
  'data-testid': dataTestId,
  ...props
}) => {
  const { enhancedColumns, clipboardProps } = useDataGridEnhancer({
    columns: props.columns,
    enableClipboard,
    onClipboardCopy,
    onClipboardPaste,
  });

  const exportProps = enableExport
    ? {}
    : {
        slots: {},
      };

  return (
    <DataGridPremium
      {...DATAGRID_DEFAULT_PROPS}
      {...clipboardProps}
      {...exportProps}
      {...props}
      columns={enhancedColumns || []}
      className={treeData ? 'data-grid-tree-data' : undefined}
      sx={{
        ...DATAGRID_STYLES,
        ...sx,
      }}
      treeData={treeData}
      slotProps={{
        ...props.slotProps,
        root: {
          ...props.slotProps?.root,
          'data-testid': dataTestId,
        },
      }}
    />
  );
};

export default StyledDataGrid;
